import { loadVGSCollect } from "@vgs/collect-js";
import type { IVGSCollect } from "@vgs/collect-js-react";
import type { VgsConfig } from "./vgsConfig";

let collectLoad: Promise<IVGSCollect> | null = null;

export function loadVgsCollect({
    vaultId,
    environment,
    collectVersion,
    collectIntegrity,
}: Pick<
    VgsConfig,
    "vaultId" | "environment" | "collectVersion" | "collectIntegrity"
>): Promise<IVGSCollect> {
    collectLoad ??= loadVGSCollect({
        vaultId,
        environment,
        version: collectVersion,
        integrity: collectIntegrity,
        crossorigin: "anonymous",
    })
        .then(() => {
            if (!window.VGSCollect) {
                throw new Error("VGS Collect.js loaded without VGSCollect");
            }
            return window.VGSCollect;
        })
        .catch((error) => {
            collectLoad = null;
            throw error;
        });
    return collectLoad;
}
